import { ASSET_CLASS_IDS } from "~/consts";
import { Asset } from "../modules/assets/types";

// // // //

export function isStablecoin(props: { asset: Asset }): boolean {
    return props.asset.asset_class_id === ASSET_CLASS_IDS.Stablecoin;
}

export function isCommodity(props: { asset: Asset }): boolean {
    return props.asset.asset_class_id === ASSET_CLASS_IDS.Commodities;
}

export function isPublicEquity(props: { asset: Asset }): boolean {
    return props.asset.asset_class_id === ASSET_CLASS_IDS.Stocks;
}

export function isFiatCurrency(props: { asset: Asset }): boolean {
    return props.asset.asset_class_id === ASSET_CLASS_IDS.FiatCurrency;
}

export function isRealEstate(props: { asset: Asset }): boolean {
    return props.asset.asset_class_id === ASSET_CLASS_IDS.RealEstate;
}

export function isUnderlyingStock(props: { asset: Asset }): boolean {
    return isPublicEquity(props) && props.asset.token_count === 0;
}
